/**
 * Tiny pub/sub for "EdgeWeb is busy fetching something big". Set from the
 * data layer (currently: DICOMweb provider while pulling a series'
 * per-instance metadata); rendered by the Viewer's progress banner.
 *
 * Multiple concurrent fetches collapse to the latest reporter — the
 * viewer shows one strip at a time, not N stacked banners. If real
 * concurrency reporting is needed later, key it by series-uid.
 */
import { create } from 'zustand';

interface DataProgressState {
  active: boolean;
  /** Short caption — e.g. "Loading series metadata" */
  label: string;
  /** Items loaded so far (e.g. instances whose metadata has arrived). */
  loaded: number;
  /** Best-known total. 0 means unknown (caption falls back to "Loading…"). */
  total: number;
  start: (label: string, total: number) => void;
  bump: (loaded: number) => void;
  done: () => void;
}

export const useDataProgress = create<DataProgressState>((set) => ({
  active: false,
  label: '',
  loaded: 0,
  total: 0,
  start: (label, total) => set({ active: true, label, loaded: 0, total }),
  bump: (loaded) => set({ loaded }),
  done:  () => set({ active: false, label: '', loaded: 0, total: 0 }),
}));
